import * as DiscountCodeApiActions from "@app/modules/discount-codes/actions/discount-code-api.actions"
import { DiscountCodeTableItemModel } from "@app/modules/discount-codes/models/discount-code-table.model"
import { TableOverviewModel } from "@app/shared/models/table/table-overview.model"
import { TableStateModel } from "@app/shared/models/table/table-state.model"
import { applySortingOrDefault } from "@app/shared/utilities/overview-reducer.utilities"
import { createReducer, on } from "@ngrx/store"

const initialState: State = new TableOverviewModel<DiscountCodeTableItemModel>('code');

export interface State extends TableStateModel<DiscountCodeTableItemModel> { }

export const reducer = createReducer(initialState,
    on(DiscountCodeApiActions.GetOverview, (state) => ({ ...state, loading: true })),
    on(DiscountCodeApiActions.GetOverviewSuccess, (state, response) => ({ ...state, ...response, loading: false })),
    on(DiscountCodeApiActions.GetOverviewError, (state) => ({ ...state, loading: false })),
    on(DiscountCodeApiActions.FilterOverview, (state, { sorting, pagination }) => ({ 
        ...state, 
        sorting: applySortingOrDefault(initialState, sorting),
        pagination: { 
            ...state.pagination, 
            page: pagination.page,
            pageSize: pagination.pageSize
        } 
    })),
    on(DiscountCodeApiActions.ResetOverview,  () => ({ ...initialState }))
)

export const getLoading = (state: State) => state.loading;
export const getList = (state: State) => state.list;
export const getPagination = (state: State) => state.pagination;
export const getSorting = (state: State) => state.sorting;